// Доля 0..1 → процент на языке интерфейса: «45 %» по-русски, «45%» по-английски.
export const formatPercent = (share: number, locale: string): string =>
  new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 0 }).format(share);
